module.exports = __webpack_public_path__ + "img/openLive.4acbcafc.png";